module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._t("default", null, {
    text: _vm.redval
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1330dc74"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tipnotes.vue
// module id = 881
// module chunks = 1